/**
 * @generated SignedSource<<f2fa79ade3fd6c1523636332314743da>>
 * @relayHash 0b80f6b190b9098f1041c5e364d95852
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 69272838933688029bd3af75ee71f457c3de45b2f1a60918fa4cd89a11f6eec5

import type { ConcreteRequest, Query } from 'relay-runtime';
export type DevOpsEnvironmentCategory = "DEVELOPMENT" | "PRODUCTION" | "STAGING" | "TESTING" | "UNMAPPED" | "%future added value";
export type DevOpsMetricsPerDeploymentMetricsFilter = {
  cloudId: string;
  endAtExclusive: AGG$DateTime;
  environmentCategories?: ReadonlyArray<DevOpsEnvironmentCategory>;
  jiraProjectIds?: ReadonlyArray<string> | null | undefined;
  startFromInclusive: AGG$DateTime;
};
export type perDeploymentMetricsRelayQuery$variables = {
  filter: DevOpsMetricsPerDeploymentMetricsFilter;
};
export type perDeploymentMetricsRelayQuery$data = {
  readonly devOpsMetrics: {
    readonly perDeploymentMetrics: {
      readonly nodes: ReadonlyArray<{
        readonly deployment: {
          readonly displayName: string;
          readonly environment: {
            readonly displayName: string;
          };
          readonly id: string;
          readonly issueIds: ReadonlyArray<string>;
          readonly lastUpdated: AGG$DateTime;
          readonly pipeline: {
            readonly displayName: string;
            readonly url: string;
          };
          readonly url: string;
        };
        readonly deploymentSize: AGG$Long;
      } | null | undefined>;
    };
  };
};
export type perDeploymentMetricsRelayQuery = {
  response: perDeploymentMetricsRelayQuery$data;
  variables: perDeploymentMetricsRelayQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filter"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "filter",
    "variableName": "filter"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 400
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "deploymentSize"
},
v3 = {
  "kind": "ScalarField",
  "name": "id"
},
v4 = {
  "kind": "ScalarField",
  "name": "issueIds"
},
v5 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v6 = {
  "kind": "ScalarField",
  "name": "url"
},
v7 = {
  "kind": "ScalarField",
  "name": "lastUpdated"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "perDeploymentMetricsRelayQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "DevOpsMetrics",
          "kind": "LinkedField",
          "name": "devOpsMetrics",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "args": (v1/*: any*/),
                "concreteType": "DevOpsMetricsPerDeploymentMetricsConnection",
                "kind": "LinkedField",
                "name": "perDeploymentMetrics",
                "plural": false,
                "selections": [
                  {
                    "kind": "RequiredField",
                    "field": {
                      "concreteType": "DevOpsMetricsDeploymentMetrics",
                      "kind": "LinkedField",
                      "name": "nodes",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "RequiredField",
                          "field": (v2/*: any*/),
                          "action": "THROW",
                          "path": "devOpsMetrics.perDeploymentMetrics.nodes.deploymentSize"
                        },
                        {
                          "kind": "RequiredField",
                          "field": {
                            "concreteType": "DeploymentSummary",
                            "kind": "LinkedField",
                            "name": "deployment",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "RequiredField",
                                "field": (v3/*: any*/),
                                "action": "THROW",
                                "path": "devOpsMetrics.perDeploymentMetrics.nodes.deployment.id"
                              },
                              {
                                "kind": "RequiredField",
                                "field": (v4/*: any*/),
                                "action": "THROW",
                                "path": "devOpsMetrics.perDeploymentMetrics.nodes.deployment.issueIds"
                              },
                              {
                                "kind": "RequiredField",
                                "field": (v5/*: any*/),
                                "action": "THROW",
                                "path": "devOpsMetrics.perDeploymentMetrics.nodes.deployment.displayName"
                              },
                              {
                                "kind": "RequiredField",
                                "field": (v6/*: any*/),
                                "action": "THROW",
                                "path": "devOpsMetrics.perDeploymentMetrics.nodes.deployment.url"
                              },
                              {
                                "kind": "RequiredField",
                                "field": (v7/*: any*/),
                                "action": "THROW",
                                "path": "devOpsMetrics.perDeploymentMetrics.nodes.deployment.lastUpdated"
                              },
                              {
                                "kind": "RequiredField",
                                "field": {
                                  "concreteType": "DevOpsEnvironment",
                                  "kind": "LinkedField",
                                  "name": "environment",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "kind": "RequiredField",
                                      "field": (v5/*: any*/),
                                      "action": "THROW",
                                      "path": "devOpsMetrics.perDeploymentMetrics.nodes.deployment.environment.displayName"
                                    }
                                  ]
                                },
                                "action": "THROW",
                                "path": "devOpsMetrics.perDeploymentMetrics.nodes.deployment.environment"
                              },
                              {
                                "kind": "RequiredField",
                                "field": {
                                  "concreteType": "DeploymentPipeline",
                                  "kind": "LinkedField",
                                  "name": "pipeline",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "kind": "RequiredField",
                                      "field": (v6/*: any*/),
                                      "action": "THROW",
                                      "path": "devOpsMetrics.perDeploymentMetrics.nodes.deployment.pipeline.url"
                                    },
                                    {
                                      "kind": "RequiredField",
                                      "field": (v5/*: any*/),
                                      "action": "THROW",
                                      "path": "devOpsMetrics.perDeploymentMetrics.nodes.deployment.pipeline.displayName"
                                    }
                                  ]
                                },
                                "action": "THROW",
                                "path": "devOpsMetrics.perDeploymentMetrics.nodes.deployment.pipeline"
                              }
                            ]
                          },
                          "action": "THROW",
                          "path": "devOpsMetrics.perDeploymentMetrics.nodes.deployment"
                        }
                      ]
                    },
                    "action": "THROW",
                    "path": "devOpsMetrics.perDeploymentMetrics.nodes"
                  }
                ]
              },
              "action": "THROW",
              "path": "devOpsMetrics.perDeploymentMetrics"
            }
          ]
        },
        "action": "THROW",
        "path": "devOpsMetrics"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "perDeploymentMetricsRelayQuery",
    "selections": [
      {
        "concreteType": "DevOpsMetrics",
        "kind": "LinkedField",
        "name": "devOpsMetrics",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "DevOpsMetricsPerDeploymentMetricsConnection",
            "kind": "LinkedField",
            "name": "perDeploymentMetrics",
            "plural": false,
            "selections": [
              {
                "concreteType": "DevOpsMetricsDeploymentMetrics",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "concreteType": "DeploymentSummary",
                    "kind": "LinkedField",
                    "name": "deployment",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      {
                        "concreteType": "DevOpsEnvironment",
                        "kind": "LinkedField",
                        "name": "environment",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "DeploymentPipeline",
                        "kind": "LinkedField",
                        "name": "pipeline",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v5/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "69272838933688029bd3af75ee71f457c3de45b2f1a60918fa4cd89a11f6eec5",
    "metadata": {},
    "name": "perDeploymentMetricsRelayQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "a444cbdff40b5c591f2bfdb2909358a7";

export default node;
